import { RoleGetByIdAPI, UpdateRoleAPI, creteRoleAPI, deleteRoleAPI, getRoleUserMappingAPI, getRolePagingAPI, deleteRoleUserMappingAPI, getRoleNotInUsersAPI, createRolUserMappingAPI, getRoleModulesMappingAPI, deleteRoleModuleMappingAPI, createRoleModulesAPI, getRoleApplicationMappingAPI, deleteRoleApplicationMappingAPI, getRoleNotInApplicationsAPI, createRolApplicationMappingAPI, roleFeaturePagingAPI, deleteRoleFeatureMappingAPI, getRoleNotInFeaturesAPI, roleFeatureCreateAPI, getMenuByRoleIdAPI } from "../../../api/url"
import { ResponseObject } from "../../../common/common.entity"
import { formatTreeViewData } from "../../../common/commonFunctions"
import { createAPI, deleteAPI, getByBodyAPI, getByIdAPI, setReducerState, updateAPI } from "../../../redux/crudSlice"
import { AppDispatch, store } from '../../../store/store'
import { getLocalStorageItem } from "../../../utils/storageHelper"
import { RoleKeys } from "./entity"
const { dispatch } = store

export interface APIParams {
    key?: string,
    url?: string,
    request?: ResponseObject
    state?: ResponseObject
}

export type APICallFunction = (params: APIParams) => Promise<ResponseObject> | undefined

export const getRolePagingData = async (dispatch: AppDispatch, request: ResponseObject) => {
    // const { key = RoleKeys.paging, url = getRolePagingAPI, request = {} } = params;
    request['ApplicationId'] = getLocalStorageItem('ApplicationId');
    const res = await dispatch(getByBodyAPI({ key: RoleKeys.paging, url: getRolePagingAPI, request: request }))
    return res?.payload?.value;
}

export const deleteRole = async (dispatch: AppDispatch, id: string) => {
    // const { key = RoleKeys.delete, url = deleteRoleAPI, request = {} } = params;
    const res = await dispatch(deleteAPI({ key: RoleKeys.delete, url: deleteRoleAPI, request: { RoleId: id } }))
    return res?.payload?.value;
}

export const getRolebyId: APICallFunction = async (params) => {
    const { key = RoleKeys.get, request = {}, url = RoleGetByIdAPI(request?.id) } = params;
    const res = await dispatch(getByIdAPI({ key: key, url: url }));
    return res?.payload?.value;
}

export const createRole: APICallFunction = async (params) => {
    const { key = RoleKeys.create, request = {}, url = creteRoleAPI } = params;
    request['ApplicationId'] = getLocalStorageItem('ApplicationId');
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const updateRole: APICallFunction = async (params) => {
    const { key = RoleKeys.update, request = {}, url = UpdateRoleAPI(request.id) } = params;
    const res = await dispatch(updateAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getRoleNotInUsers: APICallFunction = async (params) => {
    const { key = RoleKeys.notInUsers, request = {}, url = getRoleNotInUsersAPI } = params;
    const res = await dispatch(getByBodyAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const updateRoleUserMapping: APICallFunction = async (params) => {
    const { key = RoleKeys.addUserMapping, request = {}, url = createRolUserMappingAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getRoleUserMapping = async (dispatch: AppDispatch, request: ResponseObject) => {
    const params = { key: RoleKeys.getUserMapping, request, url: getRoleUserMappingAPI };
    const res = await dispatch(getByBodyAPI(params));
    return res?.payload?.value;
}

export const deleteRoleUserMapping = async (dispatch: AppDispatch, request: ResponseObject) => {
    const params = { key: RoleKeys.deleteUserMapping, request: [request], url: deleteRoleUserMappingAPI }
    const res = await dispatch(deleteAPI(params));
    return res?.payload?.value;
}

export const getRoleModuleMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: RoleKeys.getModuleMapping,
        url: getRoleModulesMappingAPI,
        request: { ..._request },
    }))
}

export const deleteRoleModuleMapping = async (dispatch: AppDispatch, _request: Object) => {
    const key = RoleKeys.deleteModuleMapping, request = [_request], url = deleteRoleModuleMappingAPI;
    const res = await dispatch(deleteAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const createRoleModuleMapping: APICallFunction = async (params) => {
    const { key = RoleKeys.addModuleMapping, request = {}, url = createRoleModulesAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getRoleNotInModules: APICallFunction = async (params) => {
    const { key = RoleKeys.notInModules, request = {}, url = getMenuByRoleIdAPI } = params;
    let loadingKey = 'isLoading' + key
    dispatch(setReducerState({ key: loadingKey, value: 'loading' }));

    let res = await dispatch(getByBodyAPI({ key: '', url: url, request: request }));
    res = { data: formatTreeViewData(res?.payload?.data, 'ChildName', 'DisplayName', (item: any) => (item?.children?.length > 0 || item['MenuId'])) };

    dispatch(setReducerState({ key: key, value: res }));
    dispatch(setReducerState({ key: loadingKey, value: 'idle' }));
    return res
}

export const getRoleApplicationMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: RoleKeys.getApplicationMapping,
        url: getRoleApplicationMappingAPI,
        request: { ..._request },
    }))
}

export const deleteRoleApplicationMapping = async (dispatch: AppDispatch, _request: Object) => {
    const res = await dispatch(deleteAPI({
        key: RoleKeys.deleteApplicationMapping,
        url: deleteRoleApplicationMappingAPI,
        request: [_request]
    }))
    return res?.payload?.value
}

export const createRoleApplicationMapping: APICallFunction = async (params) => {
    const { key = RoleKeys.addApplicationMapping, request = {}, url = createRolApplicationMappingAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getRoleNotInApplication: APICallFunction = async (params) => {
    const { key = RoleKeys.notInApplication, request = {}, url = getRoleNotInApplicationsAPI } = params;
    const res = await dispatch(getByBodyAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}

export const getRoleFeatureMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(getByBodyAPI({
        key: RoleKeys.getFeatureMapping,
        url: roleFeaturePagingAPI,
        request: { ..._request },
    }))
}

export const deleteRoleFeatureMapping = async (dispatch: AppDispatch, _request: Object) => {
    await dispatch(deleteAPI({
        key: RoleKeys.deleteFeatureMapping,
        url: deleteRoleFeatureMappingAPI,
        request: [_request],
    }))
}

export const getRoleNotInFeatures: APICallFunction = async (params) => {
    const { key = RoleKeys.notInFeatures, request = {}, url = getRoleNotInFeaturesAPI } = params;
    let loadingKey = 'isLoading' + key
    dispatch(setReducerState({ key: loadingKey, value: 'loading' }));

    let res = await dispatch(getByBodyAPI({ key: '', url: url, request: request }));
    res = { data: formatTreeViewData(res?.payload?.data, 'ChildName', 'DisplayName', (item) => (item?.children?.length > 0 || item['FeatureId'])) };

    dispatch(setReducerState({ key: key, value: res }));
    dispatch(setReducerState({ key: loadingKey, value: 'idle' }));
    return res
}

export const createRoleFeatureMapping: APICallFunction = async (params) => {
    const { key = RoleKeys.addFeatureMapping, request = {}, url = roleFeatureCreateAPI } = params;
    const res = await dispatch(createAPI({ key: key, url: url, request: request }));
    return res?.payload?.value;
}